import { render, staticRenderFns } from "./autonym.vue?vue&type=template&id=373b7644&scoped=true"
import script from "./autonym.vue?vue&type=script&lang=js"
export * from "./autonym.vue?vue&type=script&lang=js"
import style0 from "./autonym.vue?vue&type=style&index=0&id=373b7644&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373b7644",
  null
  
)

export default component.exports